export default __webpack_public_path__ + "static/documentation-15fe146534f7f3e1d01662229e202dc2.svg";